// Consultas compartidas (React Query) sobre la API de comercial.
import { useQuery } from "@tanstack/react-query";
import { leer } from "./api";
import { useSesion } from "./sesion";
import type { EstadoOdoo, PersonaEquipo, Producto, Yo } from "./tipos";

export function useYo() {
  const { api, listo } = useSesion();
  return useQuery({ queryKey: ["yo"], queryFn: () => api.api.yo.$get().then((r) => leer<Yo>(r)), enabled: listo, staleTime: 5 * 60_000 });
}

export function useEquipo() {
  const { api, listo } = useSesion();
  return useQuery({ queryKey: ["equipo"], queryFn: () => api.api.equipo.$get().then((r) => leer<{ equipo: PersonaEquipo[] }>(r)), enabled: listo, staleTime: 5 * 60_000 });
}

export function useProductos() {
  const { api, listo } = useSesion();
  return useQuery({ queryKey: ["productos"], queryFn: () => api.api.productos.$get().then((r) => leer<{ productos: Producto[]; sinPrecios: boolean }>(r)), enabled: listo, staleTime: 5 * 60_000 });
}

export function useOdoo() {
  const { api, listo } = useSesion();
  return useQuery({ queryKey: ["odoo"], queryFn: () => api.api.odoo.$get().then((r) => leer<EstadoOdoo>(r)), enabled: listo, staleTime: 60_000, refetchInterval: 5 * 60_000 });
}

export function useSalud() {
  return useQuery({ queryKey: ["salud"], queryFn: () => fetch("/api/salud").then((r) => leer<{ ok: boolean; baseDeDatos: boolean; odoo: boolean; ia: boolean; correo: boolean }>(r)), staleTime: 5 * 60_000 });
}

/** Mapa clave → nombre del catálogo, para no enseñar claves como «revista-360». */
export function useNombresProducto(): (clave: string) => string {
  const q = useProductos();
  const mapa = new Map((q.data?.productos ?? []).map((p) => [p.clave, p.nombre] as const));
  return (clave) => mapa.get(clave) ?? clave;
}
